import React from 'react';
import styled, { css } from 'styled-components';
import { breakpointMap, BreakpointsOfTOrT, theme } from '../../../theme';

export type UITextSize = 'xxs' | 'xs' | 'sm' | 'md' | 'lg';

type BaseUITextProps = React.HTMLAttributes<HTMLParagraphElement>;

export type StyledUITextProps = {
  size: BreakpointsOfTOrT<UITextSize>;
  color?: string;
};

type CombinedUITextProps = BaseUITextProps & StyledUITextProps;

export const BaseUITextStyles = css<StyledUITextProps>`
  color: ${({ color }) => (color ? color : theme.colors.primary.graysGray)};
  padding: 0;
  margin: 0;

  ${({ size }) =>
    breakpointMap(size, (UITextSize) => theme.typography.uiText[UITextSize])};
`;

const BaseUIText = styled.p<CombinedUITextProps>`
  ${BaseUITextStyles};
`;

export type UITextProps = Partial<CombinedUITextProps>;

export const UIText: React.FC<UITextProps> = ({
  children,
  size = 'md',
  ...props
}) => {
  return (
    <BaseUIText size={size} {...props}>
      {children}
    </BaseUIText>
  );
};
